import requests from "./httpService";

const SprintServices = {
  getSprints(companyId, projectId = null) {
    let url = `/sprints?company_id=${companyId}`;
    if (projectId) {
      url += `&project_id=${projectId}`;
    }
    return requests.get(url);
  },
  createSprint(body) {
    return requests.post(`/sprints/create`, body);
  },
  updateSprint(id, body) {
    return requests.post(`/sprints/update/${id}`, body);
  },
  deleteSprint(id) {
    return requests.delete(`/sprints/delete/${id}`);
  },
  uploadAttachment(id, formData, config) {
    return requests.post(`/sprints/attachments/${id}`, formData, config);
  },
  deleteAttachment(id) {
    return requests.post(`/sprints/attachmentdelete/${id}`, {});
  }
};

export default SprintServices;
